import { render, staticRenderFns } from "./ProductViewPage.vue?vue&type=template&id=3f383ca0&scoped=true&"
import script from "./ProductViewPage.vue?vue&type=script&lang=js&"
export * from "./ProductViewPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductViewPage.vue?vue&type=style&index=0&id=3f383ca0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f383ca0",
  null
  
)

export default component.exports